var map = {
	"./Parceiro 1.png": 9685,
	"./Parceiro 10.png": 8705,
	"./Parceiro 11.png": 7576,
	"./Parceiro 12.png": 5712,
	"./Parceiro 13.png": 4474,
	"./Parceiro 14.png": 1349,
	"./Parceiro 15.png": 8460,
	"./Parceiro 16.png": 6567,
	"./Parceiro 17.png": 990,
	"./Parceiro 18.png": 2905,
	"./Parceiro 19.png": 6656,
	"./Parceiro 2.png": 5678,
	"./Parceiro 20.png": 5132,
	"./Parceiro 21.png": 8021,
	"./Parceiro 22.png": 2270,
	"./Parceiro 23.png": 9959,
	"./Parceiro 24.png": 8440,
	"./Parceiro 25.png": 8385,
	"./Parceiro 26.png": 74,
	"./Parceiro 27.png": 5299,
	"./Parceiro 28.png": 1428,
	"./Parceiro 29.png": 7581,
	"./Parceiro 3.png": 4903,
	"./Parceiro 30.png": 4647,
	"./Parceiro 31.png": 1630,
	"./Parceiro 32.png": 3429,
	"./Parceiro 33.png": 4012,
	"./Parceiro 34.png": 3971,
	"./Parceiro 35.png": 8762,
	"./Parceiro 36.png": 7745,
	"./Parceiro 37.png": 9480,
	"./Parceiro 38.png": 6959,
	"./Parceiro 39.png": 7942,
	"./Parceiro 4.png": 5912,
	"./Parceiro 40.png": 9098,
	"./Parceiro 41.png": 4307,
	"./Parceiro 42.png": 9816,
	"./Parceiro 43.png": 8081,
	"./Parceiro 44.png": 1966,
	"./Parceiro 45.png": 7364,
	"./Parceiro 46.png": 4348,
	"./Parceiro 47.png": 3765,
	"./Parceiro 48.png": 6818,
	"./Parceiro 49.png": 4299,
	"./Parceiro 5.png": 3393,
	"./Parceiro 50.png": 8997,
	"./Parceiro 51.png": 9900,
	"./Parceiro 52.png": 2340,
	"./Parceiro 53.png": 1646,
	"./Parceiro 54.png": 2657,
	"./Parceiro 55.png": 6059,
	"./Parceiro 56.png": 67,
	"./Parceiro 57.png": 2490,
	"./Parceiro 6.png": 2810,
	"./Parceiro 7.png": 8019,
	"./Parceiro 8.png": 6372,
	"./Parceiro 9.png": 9405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 731;